import axios from "axios";
import { baseUrl } from "../service/api";

// Uploads a single File/Blob to the server, which stores it in Google Cloud
// Storage and returns the public URL.
//
// This replaces the previous direct-to-S3 uploads that required AWS
// credentials to be embedded in the browser bundle (a credential-exposure
// risk). The browser now only talks to our own API.
export const uploadImage = async (file) => {
  const formData = new FormData();
  // file may be a Blob from browser-image-compression; without an explicit
  // filename the server receives "blob" and stores the object extensionless.
  formData.append("image", file, file.name || "upload.jpg");
  try {
    const { data } = await axios.post(
      `${baseUrl}/products/image-upload`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return data.url;
  } catch (err) {
    if (err.response) {
      const { status, data, statusText } = err.response;
      if (status === 413) {
        throw new Error("file too large — the server accepts up to 32MB");
      }
      const detail = (data && (data.error || data.message)) || statusText;
      throw new Error(`server responded ${status}${detail ? ` (${detail})` : ""}`);
    }
    if (err.request) {
      // Request left the browser but no response came back (blocked,
      // offline, dropped mid-transfer, or CORS-less 413 from Google).
      throw new Error(
        "no response from server — check your connection, VPN or ad-blocker"
      );
    }
    throw err;
  }
};
